import script from "./RecordingApp.vue.ts?vue&type=script&setup=true&lang=ts!=!../node_modules/vue-loader/dist/index.js??ruleSet[0]!./RecordingApp.vue?vue&type=script&setup=true&lang=ts"
export * from "./RecordingApp.vue.ts?vue&type=script&setup=true&lang=ts!=!../node_modules/vue-loader/dist/index.js??ruleSet[0]!./RecordingApp.vue?vue&type=script&setup=true&lang=ts"

import "./RecordingApp.vue.scss?vue&type=style&index=0&id=09c1d1d4&lang=scss!=!../node_modules/vue-loader/dist/index.js??ruleSet[0]!./RecordingApp.vue?vue&type=style&index=0&id=09c1d1d4&lang=scss"

const __exports__ = script;

export default __exports__